import CircularProgress from "@mui/material/CircularProgress";

const FullscreenLoader = () => (
    <section
        style={{
            width: "100vw",
            height: "100vh",
            position: "fixed",
            top: 0,
            left: 0,
            background: "#0000007a",
            zIndex: 5,
        }}
    >
        <div
            style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
            }}
        >
            <CircularProgress
                size={30}
                style={{ color: "#fff" }}
            />
            <br />
            <span className="text-sm color-white">Authenticating...</span>
        </div>
    </section>
);
export default FullscreenLoader;
